import React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'

import { actionCreators } from '@/store/CodeLists'
import Icon from '@/components/Icon'

import { Main, MainTop, MainTopTitle, MainBody } from '@/components/Layout'
import Resx from '@/components/Resx'
import LoadingIndicator from '@/components/LoadingIndicator'

function mapStateToProps (state) {
  return {
    processing: state.codeLists.processing,
    availableCodeLists: state.codeLists.availableCodeLists
  }
}

const mapDispatchToProps = {
  getAvailableCodeLists: actionCreators.getAvailableCodeLists
}

@connect(mapStateToProps, mapDispatchToProps)
class CodeListsEditor extends React.Component {
  constructor (props, context) {
    super(props, context)

    this.props.getAvailableCodeLists()

    this.state = {
      availableCodeLists: props.availableCodeLists
    }
  }

  componentWillReceiveProps (nextProps) {
    this.setState({
      availableCodeLists: nextProps.availableCodeLists
    })
  }

  render () {
    const { processing } = this.props
    const codeListsList = this.state.availableCodeLists.length
      ? this.state.availableCodeLists.map((codeList) => <div className='line-edit' key={codeList}><div className='line-edit__left'><strong>{<Resx name={`CodeLists.${codeList}`} />}</strong></div> <div className='btn-actions'><Link className='btn-icon' to={`/code-lists/${codeList}`}><Icon name='pencil' /></Link></div></div>) : <div />

    return (
      <Main>
        <MainTop>
          <MainTopTitle><Resx name='CodeLists.CodeListManagement' /></MainTopTitle>
        </MainTop>
        <MainBody>
          { processing === true
            ? <LoadingIndicator />
            : <div className='col-3-style'>{codeListsList}</div>
          }
        </MainBody>
      </Main>
    )
  }
}

export default CodeListsEditor



// WEBPACK FOOTER //
// ./src/internal-app/components/codeLists/codeListsEditor.js